import { ValidationError } from 'yup';

import { DISCHARGE_REASON_OTHER } from './constants';
import { DISCHARGE_CRITERIA_SCHEMA, DISCHARGE_REASON_DRAFT_SCHEMA } from './validationSchema';

import type {
  DischargeCriteriaFieldName,
  DischargeCriteriaPayload,
  DischargeReasonPayload,
  IDischargeReason,
  ITreatmentPlanV3DischargePage,
} from '../../../../../store/treatmentPlanV3';
import type { DischargeCriteriaFormValues, DischargeReasonDraftValues } from './types';

export function mapDischargePageToCriteriaValues(
  dischargePage: ITreatmentPlanV3DischargePage,
): DischargeCriteriaFormValues {
  return {
    mastery_of_program_goals: dischargePage.mastery_of_program_goals ?? '',
    titration_plan: dischargePage.titration_plan ?? '',
    readiness_to_step_down: dischargePage.readiness_to_step_down ?? '',
    care_coordination: dischargePage.care_coordination ?? '',
  };
}

export function toDischargeCriteriaFieldPayload(
  name: DischargeCriteriaFieldName,
  values: DischargeCriteriaFormValues,
): DischargeCriteriaPayload {
  const data: DischargeCriteriaPayload = {};
  data[name] = values[name] || null;
  return data;
}

export function getDischargeReasonRowLabel(reason: IDischargeReason): string {
  if (reason.reason === DISCHARGE_REASON_OTHER) {
    return `${DISCHARGE_REASON_OTHER}: ${reason.explanation ?? ''}`;
  }
  return reason.reason;
}

export function toDischargeReasonPayload(
  draft: DischargeReasonDraftValues,
): DischargeReasonPayload {
  if (draft.reason === DISCHARGE_REASON_OTHER) {
    return { reason: draft.reason, explanation: draft.explanation.trim() };
  }
  return { reason: draft.reason };
}

export function getDischargeReasonDraftError(draft: DischargeReasonDraftValues) {
  try {
    DISCHARGE_REASON_DRAFT_SCHEMA.validateSync(draft);
    return undefined;
  } catch (error) {
    return error instanceof ValidationError ? error.message : undefined;
  }
}

export function hasDischargeFormErrors(page: ITreatmentPlanV3DischargePage) {
  if (page.reasons.length === 0) return true;
  if (!DISCHARGE_CRITERIA_SCHEMA.isValidSync(mapDischargePageToCriteriaValues(page))) return true;
  return page.reasons.some(
    (row) =>
      !DISCHARGE_REASON_DRAFT_SCHEMA.isValidSync({
        reason: row.reason,
        explanation: row.explanation ?? '',
      }),
  );
}
